import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCheck, faCog } from '@fortawesome/free-solid-svg-icons';
import { VideoSpeed } from '../../../../../@domain/video/entities/video-speed.interface';

@Component({
    selector: 'app-video-player-speeds',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        FaIconComponent
    ],
    styles: `
      @use "variables" as *;
      @use "functions" as *;

      .video-speeds {
        margin-right: 2rem;
        cursor: pointer;
        position: relative;
        display: flex;

        @include break(540px) {
          margin-right: 1rem;
        }
      }

      .overlay {
        position: absolute;
        display: flex;
        flex-direction: column;
        top: 0;
        left: 50%;
        transform: translate(-50%, -105%);
        min-width: 100px;
        z-index: 10;
        background-color: $dark;
        opacity: 0.85;

        &.hide {
          opacity: 0;
          pointer-events: none;
        }
      }

      .video-speed {
        display: flex;
        align-items: center;
        padding: 0.25rem 0.5rem;

        .check {
          display: flex;
          justify-content: center;
          width: 35px;

          fa-icon {
            font-size: 12px;
          }
        }

        span {
          font-size: 14px;
        }

        &:hover {
          background-color: #434343;
        }
      }
    `,
    template: `
        <div class="video-speeds" (click)="onToggle()">
            <fa-icon [icon]="faCog" title="Playback speed"/>
            <div class="overlay" [class.hide]="!showSpeeds">
                @for (videoSpeed of videoSpeeds; track videoSpeed) {
                    <div class="video-speed" (click)="onClick(videoSpeed)">
                        <div class="check">
                            @if (videoSpeed.checked) {
                                <fa-icon [icon]="faCheck"/>
                            }
                        </div>
                        <span>{{ videoSpeed.speed }}</span>
                    </div>
                }
            </div>
        </div>
    `
})
export class VideoPlayerSpeedsComponent {
    @Output() onVideoSpeedClick = new EventEmitter<number>();
    showSpeeds: boolean = false;
    videoSpeeds: VideoSpeed[] = [
        {
            checked: false,
            speed: 0.25,
        },
        {
            checked: false,
            speed: 0.5,
        },
        {
            checked: false,
            speed: 0.75,
        },
        {
            checked: true,
            speed: 1,
        },
        {
            checked: false,
            speed: 1.25,
        },
        {
            checked: false,
            speed: 1.5,
        },
        {
            checked: false,
            speed: 1.75,
        },
        {
            checked: false,
            speed: 2,
        },
    ];
    faCog = faCog;
    faCheck = faCheck;

    onToggle(): void {
        this.showSpeeds = !this.showSpeeds;
    }

    onClick(videoSpeed: VideoSpeed): void {
        this.videoSpeeds.forEach(speed => (speed.checked = videoSpeed.speed === speed.speed));
        this.onVideoSpeedClick.emit(videoSpeed.speed);
    }

}
